<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: "orderPage",
  };

</script> 

<style lang="scss">

</style>
